export default [
  {
    path: '/salary/:key?',
    name: 'salary',
    component: () => import('@/views/salary/SalaryIndex.vue'),
    meta: {},
  },
];
